import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import { translate } from 'secullum-i18n';
import {
  Card,
  DropDown,
  Message,
  RangeDatePicker,
  Space
} from 'secullum-react-native-ui';
import { Subscribe } from 'unstated';
import { ButtonBar } from '../../../shared/components/ButtonBar';
import Link from '../../../shared/components/Link';
import SolicitacaoHeader from '../../../shared/components/SolicitacaoHeader';
import SolicitacaoLinha from '../../../shared/components/SolicitacaoLinha';
import SolicitacaoProcessamento from '../../../shared/components/SolicitacaoProcessamento';
import { FuncionarioContainer } from '../../../shared/containers/FuncionarioContainer';
import {
  SolicitacoesContainer,
  getCorStatus,
  getIconeStatus
} from '../../../shared/containers/SolicitacoesContainer';
import withContainer from '../../../shared/containers/withContainer';
import { getTheme } from '../../../shared/modules/layout';
import { primeiraLetraMaisculaCadaPalavra } from '../../../shared/modules/string';
import {
  SolicitacoesDados,
  SolicitacoesFiltros,
  SolicitacoesFiltrosStatus,
  SolicitacoesStatus,
  TipoAlteracaoFonteDados,
  TipoControleSolicitacoes,
  TipoPerfil,
  TipoPlano
} from '../../../shared/modules/types';
import {
  converterDataParaTimezoneBrasil,
  getDataInicioDiasAtras
} from '../../../shared/modules/utils';
import ModalFiltrosSolicitacao, {
  FiltrosSolicitacaoValores,
  FiltroSolicitacaoOpcao
} from '../../../shared/screens/solicitacoes-gerente/ModalFiltrosSolicitacao';
import LoggedInScreen from '../../components/LoggedInScreen';
import SolicitacoesDetalhes from '../solicitacoes/SolicitacoesDetalhes';

interface Props {
  container: SolicitacoesContainer;
}

interface State {
  filtros: SolicitacoesFiltros;
  filtrosAdicionais: FiltrosSolicitacaoValores;
  erroGeral: string;
  solicitacao: SolicitacoesDados | null;
  listaIdsSelecionados: Array<number>;
  tipoAcao: TipoAlteracaoFonteDados | null;
  solicitacaoAtual: SolicitacoesDados | null;
  exibirModalFiltros: boolean;
}

class SolicitacoesGerente extends React.Component<Props, State> {
  state: State = {
    filtros: {
      dataInicio: converterDataParaTimezoneBrasil(getDataInicioDiasAtras(14)),
      dataFinal: converterDataParaTimezoneBrasil(new Date()),
      status: SolicitacoesFiltrosStatus.Pendentes,
      perfil: TipoPerfil.Gerente
    },
    filtrosAdicionais: {
      empresa: '',
      departamento: '',
      funcao: ''
    },
    erroGeral: '',
    solicitacao: null,
    listaIdsSelecionados: [],
    tipoAcao: null,
    solicitacaoAtual: null,
    exibirModalFiltros: false
  };

  listaSolicitacoesAcao: SolicitacoesDados[] = [];

  async componentDidMount() {
    await this.props.container.loadAsync(this.state.filtros);
  }

  getListaFiltrada = () => {
    const { lista } = this.props.container.state;
    const { empresa, departamento, funcao } = this.state.filtrosAdicionais;

    return lista.filter(
      x =>
        (!empresa || x.empresaNome === empresa) &&
        (!departamento || x.departamentoNome === departamento) &&
        (!funcao || x.funcaoNome === funcao)
    );
  };

  handleDateInicioChange = (value: Date) => {
    this.setState({
      filtros: { ...this.state.filtros, dataInicio: value, dataFinal: value },
      erroGeral: '',
      filtrosAdicionais: { empresa: '', departamento: '', funcao: '' }
    });
  };

  handleChange = (value: string | Date, name: keyof State['filtros']) => {
    const novosFiltros = {
      ...this.state.filtros,
      [name]: value
    };
    this.setState(
      {
        filtros: novosFiltros,
        listaIdsSelecionados: [],
        erroGeral: '',
        filtrosAdicionais: {
          empresa: '',
          departamento: '',
          funcao: ''
        }
      },
      async () => {
        if (
          this.state.filtros.dataInicio &&
          this.state.filtros.dataFinal &&
          this.state.filtros.dataInicio > this.state.filtros.dataFinal
        ) {
          this.setState({
            erroGeral: translate('Selecione o período corretamente')
          });

          return;
        }
        await this.props.container.loadAsync(this.state.filtros);
      }
    );
  };

  handleConcluirFiltros = (filtrosAdicionais: FiltrosSolicitacaoValores) => {
    this.setState({
      filtrosAdicionais,
      exibirModalFiltros: false,
      listaIdsSelecionados: [],
      erroGeral: ''
    });
  };

  handleCancelarFiltros = () => {
    this.setState({ exibirModalFiltros: false });
  };

  abrirModalFiltros = () => {
    this.setState({ exibirModalFiltros: true });
  };

  iniciarProcessamento = (tipoAcao: TipoAlteracaoFonteDados) => {
    const { listaIdsSelecionados } = this.state;
    const listaFiltrada = this.getListaFiltrada();

    this.setState({ tipoAcao });

    this.listaSolicitacoesAcao = listaFiltrada.filter(x =>
      listaIdsSelecionados.includes(x.id)
    );

    this.processarSolicitacaoAtual();
  };

  processarSolicitacaoAtual = () => {
    if (this.listaSolicitacoesAcao.length === 0) {
      this.finalizarProcessamento();
      return;
    }

    this.setState({ solicitacaoAtual: this.listaSolicitacoesAcao[0] });
  };

  finalizarProcessamento = () => {
    this.listaSolicitacoesAcao = [];

    this.setState(
      { tipoAcao: null, solicitacaoAtual: null },
      async () => await this.props.container.loadAsync(this.state.filtros)
    );
  };

  concluirEnvioSucesso = () => {
    const { solicitacaoAtual, listaIdsSelecionados } = this.state;

    if (solicitacaoAtual) {
      this.setState({
        listaIdsSelecionados: listaIdsSelecionados.filter(
          item => item !== solicitacaoAtual.id
        )
      });
    }

    this.listaSolicitacoesAcao.shift();
    this.processarSolicitacaoAtual();
  };

  handleSelecionarTodas = (checked: boolean) => {
    const listaFiltrada = this.getListaFiltrada();

    this.setState({
      listaIdsSelecionados: checked
        ? listaFiltrada
            .filter(x => x.status == SolicitacoesStatus.Pendente)
            .map(y => y.id)
        : []
    });
  };

  handleSelecionar = (solicitacaoId: number) => {
    const { listaIdsSelecionados } = this.state;

    this.setState({
      listaIdsSelecionados: listaIdsSelecionados.includes(solicitacaoId)
        ? listaIdsSelecionados.filter(item => item !== solicitacaoId)
        : [...listaIdsSelecionados, solicitacaoId]
    });
  };

  getItensFiltro = (
    seletor: (solicitacao: SolicitacoesDados) => string | undefined
  ): FiltroSolicitacaoOpcao[] => {
    const valores = this.props.container.state.lista
      .map(s => seletor(s))
      .filter((v): v is string => v !== undefined && v !== '');

    return [...new Set(valores)]
      .sort((a, b) => a.localeCompare(b))
      .map(v => ({ value: v, label: v }));
  };

  render() {
    const { container } = this.props;
    const {
      filtros,
      erroGeral,
      solicitacao,
      listaIdsSelecionados,
      solicitacaoAtual,
      tipoAcao,
      filtrosAdicionais,
      exibirModalFiltros
    } = this.state;
    const empresasFiltros = this.getItensFiltro(x => x.empresaNome);
    const departamentosFiltros = this.getItensFiltro(x => x.departamentoNome);
    const funcoesFiltros = this.getItensFiltro(x => x.funcaoNome);

    const listaSolicitacoesFiltradas = this.getListaFiltrada();

    const idsPendentes = listaSolicitacoesFiltradas
      .filter(x => x.status === SolicitacoesStatus.Pendente)
      .map(y => y.id);

    const todasSelecionadas =
      idsPendentes.length > 0 &&
      idsPendentes.every(id => listaIdsSelecionados.includes(id));

    const leftButtonAprovar = {
      disabled: listaIdsSelecionados.length === 0,
      text: translate('Aprovar'),
      onPress: () => this.iniciarProcessamento(TipoAlteracaoFonteDados.Troca),
      textStyle: styles.textButton,
      style: [styles.button, styles.buttonAprovar],
      nativeID: 'botao-aprovar-solicitacao-gerente'
    };

    const leftButtonMarcarVisto = {
      disabled: listaIdsSelecionados.length === 0,
      text: primeiraLetraMaisculaCadaPalavra(translate('Marcar Visto')),
      onPress: () =>
        this.iniciarProcessamento(TipoAlteracaoFonteDados.MarcarVisto),
      textStyle: styles.textButton,
      style: styles.button,
      nativeID: 'botao-visto-solicitacao-gerente'
    };

    const rightButton = {
      disabled: listaIdsSelecionados.length === 0,
      text: translate('Reprovar'),
      onPress: () =>
        this.iniciarProcessamento(TipoAlteracaoFonteDados.ApagarFonteDados),
      textStyle: styles.textButton,
      style: [styles.button, { backgroundColor: theme.errorColor }],
      nativeID: 'botao-reprovar-solicitacao-gerente'
    };

    return (
      <LoggedInScreen screenTitle={translate('Solicitações Gerente')}>
        <Card>
          <Card.Header title={translate('Filtrar')} />
          <Card.Section style={{ paddingLeft: 0 }}>
            <View style={styles.section}>
              <DropDown
                nativeID="solicitacoes-status"
                label={translate('Status da Solicitação')}
                items={container.getItensStatusSolicitacoes()}
                value={filtros.status}
                onChange={status => this.handleChange(status, 'status')}
                style={styles.campoFiltro}
                emptyMessage={translate('Sua busca não retornou resultados')}
              />
              <RangeDatePicker
                nativeID="solicitacoes-data"
                style={styles.campoFiltro}
                label={translate('Insira o Período')}
                startDate={filtros.dataInicio!}
                endDate={filtros.dataFinal!}
                onStartDateChange={this.handleDateInicioChange}
                onEndDateChange={date => this.handleChange(date, 'dataFinal')}
              />
              <Subscribe to={[FuncionarioContainer]}>
                {(funcionario: FuncionarioContainer) => (
                  <ButtonBar
                    buttonBarStyle={styles.buttons}
                    leftButton={
                      funcionario.state.dados.plano >= TipoPlano.Pro &&
                      funcionario.state.dados.dadosPerfilFuncionario
                        .controleSolicitacoes ===
                        TipoControleSolicitacoes.MarcarVisto
                        ? leftButtonMarcarVisto
                        : leftButtonAprovar
                    }
                    rightButton={rightButton}
                  />
                )}
              </Subscribe>
            </View>
            <Link
              nativeID="link-mais-filtros-solicitacao-gerente"
              text={translate('Filtros Adicionais')}
              onPress={this.abrirModalFiltros}
              style={styles.linkPressable}
            />
          </Card.Section>
        </Card>
        <Space height={10} />
        <Card>
          <Card.Section style={styles.headerSection}>
            {listaSolicitacoesFiltradas.length > 0 && (
              <SolicitacaoHeader
                checked={todasSelecionadas}
                showChecked={container.state.precisaProcessarSolicitacoes}
                onChecked={checked => this.handleSelecionarTodas(checked)}
              />
            )}
          </Card.Section>
        </Card>
        <Space height={10} />
        {listaSolicitacoesFiltradas.map((solicitacao, index) => (
          <SolicitacaoLinha
            key={solicitacao.id}
            exibirSeparador={index > 0}
            solicitacao={solicitacao}
            checked={listaIdsSelecionados.includes(solicitacao.id)}
            corSolicitacao={getCorStatus(solicitacao.status)}
            iconeSolicitacao={getIconeStatus(solicitacao.status)}
            onChecked={() => this.handleSelecionar(solicitacao.id)}
            onNavigate={() => {
              this.setState({ solicitacao });
            }}
          />
        ))}

        {solicitacao && (
          <SolicitacoesDetalhes
            modalVisible={solicitacao !== null}
            solicitacao={solicitacao}
            gerente={true}
            onClose={() => {
              this.finalizarProcessamento();
              this.setState({ solicitacao: null });
            }}
          />
        )}

        {solicitacaoAtual ? (
          // Precisamos gerar uma nova versão do componente
          // toda vez que uma solicitação for processada
          // pois o processamento  é iniciado no didmount do componente.
          <SolicitacaoProcessamento
            key={solicitacaoAtual.id}
            solicitacaoAtual={solicitacaoAtual}
            tipoAcao={tipoAcao}
            concluirEnvioSucesso={this.concluirEnvioSucesso}
            finalizarProcessamento={this.finalizarProcessamento}
            concluirEnvioErro={(erros: string) =>
              this.setState({ erroGeral: erros }, this.finalizarProcessamento)
            }
          />
        ) : null}

        <ModalFiltrosSolicitacao
          open={exibirModalFiltros}
          filtros={filtrosAdicionais}
          empresas={empresasFiltros}
          departamentos={departamentosFiltros}
          funcoes={funcoesFiltros}
          onConcluir={this.handleConcluirFiltros}
          onCancelar={this.handleCancelarFiltros}
        />

        <Message
          type="warning"
          visible={erroGeral != ''}
          message={erroGeral}
          onRequestClose={() => this.setState({ erroGeral: '' })}
        />
      </LoggedInScreen>
    );
  }
}

const theme = getTheme();

const styles = StyleSheet.create({
  headerSection: {
    padding: 0
  },
  campoFiltro: {
    flex: 1,
    minWidth: 250,
    maxWidth: 350,
    marginTop: 10,
    marginLeft: 16
  },
  section: {
    flexDirection: 'row',
    flex: 8,
    flexWrap: 'wrap',
    minHeight: 76,
    paddingTop: 6,
    paddingLeft: 0
  },
  buttons: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: 350,
    minWidth: 220,
    marginLeft: 16,
    marginTop: 10
  },
  button: {
    height: 42,
    maxWidth: 138
  },
  linkPressable: {
    alignSelf: 'flex-start',
    marginLeft: 16,
    marginTop: 12
  },
  buttonAprovar: {
    backgroundColor: theme.successColor
  },
  textButton: {
    fontSize: 14
  }
});

export default withContainer(SolicitacoesContainer)(SolicitacoesGerente);
